<template>
  <MDBContainer>
    <section class="my-5">
      <h2 class="text-center mb-4 fs-1">{{ webinar_info.webinar_title }}</h2>
      <p>ID:{{ webinar_info.public_id }}</p>

      <div class="text-center">
      <img
          v-if="!isNullImage && webinar_info.eyecatch_image != ''"
          :src="webinar_info.eyecatch_image"
          alt="ウェビナー紹介写真"
          class="img-fluid mx-auto mb-5"
          style="max-height: 400px;"
      >
      </div>

      <div v-html="webinar_info.webinar_description" id="description"></div>

    </section>

    <section class="button_area text-center">
      <div id="step" class="mt-5">
        <div id="step-header" class="text-center w_btn">
          <a :href="webinar_info.view_url" target="_blank" class="text-white">
            視聴/予約する
          </a>
        </div>
      </div>
    </section>
  </MDBContainer>
  <!-- Section 1 (basic information) -->
  <section>
  <div class="mt-4" id="section-title-container">
    <div id="section-title">
      <h3>基本情報</h3>
    </div>
  </div>
  <MDBContainer class="mt-1">
      <MDBTable id="basic-information-wrapper">
        <tbody>
        <tr>
          <th>開催日時</th>
          <td>
            {{ startDate }}
          </td>
        </tr>
        <tr>
          <th>視聴時間</th>
          <td>
            {{ startTime }} ～ {{ endTime }}
          </td>
        </tr>
        <tr>
          <th>参加可能人数</th>
          <td>{{webinar_info.seat_stock}}名</td>
        </tr>
        <tr>
          <th>配信ツール</th>
          <td>{{webinar_info.live_method}}</td>
        </tr>
        <tr>
          <th>配布資料</th>
          <td v-html="documentInfo"></td>
        </tr>
        </tbody>
      </MDBTable>
  </MDBContainer>
  </section>
  <!-- Section 2 (basic informations) -->
  <section id="speaker_area" v-if="isExistSpeaker">
    <MDBContainer class="p-4">
      <div id="section-title" class="section-title">
        <h3 class="text-white">登壇者</h3>
      </div>
      <MDBCard class="mb-3 text-white" v-for="teacher in webinar_info.teacher_info" :key="teacher">
        <MDBRow class="g-0">
          <MDBCol md="4">
            <img v-if="teacher.image" :src="teacher.image" 
                 class="rounded my-2" alt="登壇者のプロフィール写真">
          </MDBCol>
          <MDBCol md="8">
            <MDBCardBody>
              <MDBCardText v-html="teacher.description">
              </MDBCardText>
            </MDBCardBody>
          </MDBCol>
        </MDBRow>
      </MDBCard>
    </MDBContainer>
  </section>
  <!-- Section 3 (basic informations) -->
  <section class="mt-4" id="company_info">
    <div id="section-title-container">
      <div id="section-title">
        <h3>企業情報</h3>
      </div>
    </div>
    <MDBContainer>
      <div id="img_area">
        <img v-if="webinar_info.company_logo_image" :src="webinar_info.company_logo_image" alt="企業ロゴ">
      </div>

      <MDBTable class="mt-4">
        <tbody>
        <tr>
          <th>企業名</th>
          <td>{{ webinar_info.company_name }}</td>
        </tr>
        <tr>
          <th>所在地</th>
          <td>〒{{ webinar_info.zip }}<br>{{ webinar_info.pref }}{{ webinar_info.address1 }}{{ webinar_info.address2 }}<br>
            {{ webinar_info.address3 }}
          </td>
        </tr>
        <tr>
          <th>プロフィール</th>
          <td v-html="webinar_info.company_profile"></td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td><a v-if="webinar_info.contact_tel"
                 :href="'tel:' + webinar_info.contact_tel">
            {{ webinar_info.contact_tel }}</a></td>
        </tr>
        <tr>
          <th>メールアドレス</th>
          <td>{{ webinar_info.contact_mailaddress }}</td>
        </tr>
        <tr>
          <th>WEBサイト</th>
          <td><a v-if="webinar_info.company_url"
                 :href="webinar_info.company_url">
            {{ webinar_info.company_url }}</a></td>
        </tr>
        </tbody>
      </MDBTable>
    </MDBContainer>
  </section>
  <!-- Section 4 (webinar list) -->
  <section id="webinar_list" class="my-3 py-3 justify-content-center mx-auto">
        <div class="text-center fs-1">
          <h3 class="text-white">WEBINAR</h3>
        </div>
        <!-- <div class="row">
          <div>
            <h2 class="fw-bold text-center" style="color:var(--primary-08)">準備中</h2>
          </div>
        </div> -->
        <div class="row">
          <div class="col-12 col-md-1"></div>
          <div v-if="this.first_webinar"  class="col-12 col-md">
            <span id="webinar_nav" class="px-2 text-white fw-bold"  @click="view_webinar(this.prev_webinar.public_id)"> &lt;&lt; previous</span>
            <div v-if="this.prev_webinar!=null" class="webinar-card px-0 " @click="view_webinar(this.prev_webinar.public_id)">
              <span class="time ps-3">  {{ this.prev_webinar.webinar_start_at }}</span><br>
              <div class="desctiption text-start w-100" :class="'cat_bg_'+this.prev_webinar.genre_key">
              <span class="genre" >「{{ this.prev_webinar.genre_name }}」</span><br>
              </div>          
              <div class="desctiption text-start w-100" >
                <span class="webinar" >「{{ this.prev_webinar.webinar_title }}」</span><br>
              </div>
              <div class="desctiption text-start w-100 ">
                <span class="company">{{ this.prev_webinar.company_name }}</span>
              </div>
            </div>  
          </div>

          <div class="col-12 col-md-1"></div>

          <div v-if="this.last_webinar"  class="col-12 col-md text-end">
          <span id="webinar_nav" class="px-2  text-white fw-bold"  @click="view_webinar(this.next_webinar.public_id)"> next >></span>
            <div v-if="this.next_webinar!=null" class="webinar-card px-0 text-start" @click="view_webinar(this.next_webinar.public_id)">
              <span class="time ps-3">  {{ this.next_webinar.webinar_start_at }}</span><br>
              <div class="desctiption text-start w-100" :class="'cat_bg_'+this.next_webinar.genre_key">
              <span class="genre" >「{{ this.next_webinar.genre_name }}」</span><br>
              </div>          
              <div class="desctiption text-start w-100" >
                <span class="webinar" >「{{ this.next_webinar.webinar_title }}」</span><br>
              </div>
              <div class="desctiption text-start w-100 ">
                <span class="company">{{ this.next_webinar.company_name }}</span>
              </div>
            </div>  
          </div>
          <div class="col-12 col-md-1"></div>

        </div>
    </section>

</template>

<script>
import {Api, Http} from '@/utiles/ApiConnect';
import {MDBContainer, MDBTable, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCardText} from 'mdb-vue-ui-kit';
import dayjs from 'dayjs';
import _ from 'lodash';

export default {
  data: function() {
    return {
      webinar_info: {},
      webinar_list: [],
      prev_webinar: null,
      next_webinar: null,
      first_webinar: false,
      last_webinar: false,
    };
  },

  components: {
    MDBContainer,
    MDBTable,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBCardText,
  },

  computed: {
    isNullImage() {
      return _.isNull(this.webinar_info.eyecatch_image);
    },
    isExistSpeaker() {
      return this.webinar_info.teacher_info != null && _.isEmpty(this.webinar_info.teacher_info) === false;
    },
    startDate() {
      if(this.webinar_info.webinar_start_at!=null && this.webinar_info.webinar_start_at != ""){
        return this.webinar_info.webinar_start_at.substring(0,10);
      }
      return this.webinar_info.webinar_start_at;
    },
    endDate() {
      if(this.webinar_info.webinar_close_at!=null && this.webinar_info.webinar_close_at != ""){
        return this.webinar_info.webinar_close_at.substring(0,10);
      }
      return this.webinar_info.webinar_close_at;
    },
    startTime() {
      if(this.webinar_info.webinar_start_at!=null && this.webinar_info.webinar_start_at != ""){
        return this.webinar_info.webinar_start_at.substring(11,16);
      }
      return this.webinar_info.webinar_close_at;
    },
    endTime() {
      if(this.webinar_info.webinar_close_at!=null && this.webinar_info.webinar_close_at != ""){
        return this.webinar_info.webinar_close_at.substring(11,16);
      }
      return this.webinar_info.webinar_close_at;
    },
    documentInfo() {
      // [{"file":"","label":"Logipull製品カタログ","url":"https://logistics.cec-ltd.co.jp/download/catalog_form/"}]
      
      if(this.webinar_info.document_info!=null && this.webinar_info.document_info != ""){
        let JSONObject = JSON.parse(this.webinar_info.document_info);
        let textHtml = "";
        for(let i = 0; i<JSONObject.length;i++){
          textHtml+=`
          <a href="${JSONObject[i].url}" label="${JSONObject[i].label}">${JSONObject[i].label}<a/><br>
          `;
        }
        return textHtml;
      }
      return "";
    },
  },

  mounted: function() {
    this.getWebinarInfo();
    this.getWebinarList();
  },

  methods: {
    getWebinarInfo: function() {
      Api.connect('Webinar.Info',{public_id: this.$route.params.id,},)
        .done(function(result) {
          this.webinar_info = result.data;
        }.bind(this));
    },    
    
    updateWebinarInfo: function(pub_id) {
      Api.connect('Webinar.Info',{public_id: pub_id,},)
        .done(function(result) {
          this.webinar_info = result.data;
        }.bind(this));
    },

    getWebinarList: function() {
      Api.connect('Webinar.Search',{},)
          .done(function(result) {
            let  webinar_list = _.sortBy(result.data, ['webinar_start_at']);
            this.webinar_list = [];
            this.next_webinar = null;
            this.prev_webinar = null;
            const index = webinar_list.findIndex(webinar => webinar.public_id == this.$route.params.id);
            console.log()
            if(index==0){
              this.webinar_list.push(webinar_list[index+1]);
              this.next_webinar = webinar_list[index+1];
              this.next_webinar.webinar_start_at = this.next_webinar.webinar_start_at.substring(0, 16) + ' ~ ' + this.getWebinarEndTime(this.next_webinar.webinar_start_at.substring(11, 16));
              this.first_webinar = true;
              this.last_webinar = true;

            }else if (index == webinar_list.length){
              this.webinar_list.push(webinar_list[index-1]);
              this.prev_webinar = webinar_list[index-1];
              this.prev_webinar.webinar_start_at = this.prev_webinar.webinar_start_at.substring(0, 16) + ' ~ ' + this.getWebinarEndTime(this.prev_webinar.webinar_start_at.substring(11, 16));
              this.last_webinar = true;
            }else{
              this.prev_webinar = webinar_list[index-1];
              this.next_webinar = webinar_list[index+1];
              this.last_webinar = true;
              this.first_webinar = true;
              this.next_webinar.webinar_start_at = this.next_webinar.webinar_start_at.substring(0, 16) + ' ~ ' + this.getWebinarEndTime(this.next_webinar.webinar_start_at.substring(11, 16));
              this.prev_webinar.webinar_start_at = this.prev_webinar.webinar_start_at.substring(0, 16) + ' ~ ' + this.getWebinarEndTime(this.prev_webinar.webinar_start_at.substring(11, 16));
              this.webinar_list.push(webinar_list[index-1]);
              this.webinar_list.push(webinar_list[index+1]);
            }
            console.log(this.prev_webinar)
            console.log(this.next_webinar)
            console.log(this.webinar_list)
            // this.webinar_list = (_.sortBy(result.data, ['webinar_start_at'])).findIndex(webinar => webinar.public_id == this.$route.params.id);
            // this.webinar_list = (_.sortBy(result.data, ['webinar_start_at'])).filter((webinar)=>{return webinar.company_name==this.company.company_name});
          }.bind(this));
    },

    // Webinar詳細画面へ
    view_webinar(webinar_id) {
      this.$router.push('/webinar/' + webinar_id);
      this.updateWebinarInfo(webinar_id);
      this.getWebinarList();
    },
    
    // 時間を30っ分たす
    add30minute: function (time) {
      let temp = this.HourStrToMinute(time);
      temp = temp + 30;
      temp = this.MinuteToHourStr(temp);
      return temp;
    },

    // 時間のテックスを分に変える
    HourStrToMinute: function (Time) {
        return (parseInt(Time.hh)*60) + 
        parseInt(Time.mm);
    },

    // 分を時間のテックスに変える
    MinuteToHourStr: function (minute){
        let time ={
        hh:Math.floor(minute / 60),
        mm:minute % 60
        }
        return this.getTimeText(time);
    },

    // 時間のテックスを習得
    getTimeText: function (temp) {
        let tempM;
        let tempH;
        if (temp.mm < 10) {
        tempM = `0${temp.mm}`;
        } else {
        tempM = `${temp.mm}`;
        }
        if (temp.hh < 10) {
        tempH = `0${temp.hh}`;
        } else {
        tempH = `${temp.hh}`;
        }
        return `${tempH}:${tempM}`;
    },

    // Webinar終了時間の取得
    getWebinarEndTime: function (strtime){
      let time = {hh:strtime.substring(0, 2),mm:strtime.substring(3)};
      let inMinute = this.HourStrToMinute(time);
      inMinute = inMinute + 25;
      return this.MinuteToHourStr(inMinute);
    },

    show_webinar: function(webinar_id) {
      this.$router.push('/webinar/' + webinar_id);
    },

    getDate: function(str) {
      // return str.substring(0, 9);
    },
    
    getTime: function(str) {
      return str.substring(11, 15);
    },
  },
};
</script>

<style lang="scss">
@import "../../node_modules/mdb-vue-ui-kit/src/scss/index.free";

table {
    // border: 1px solid #A2B51E;
    font-size: 1rem;
    th {
      width: 30%;
      text-align: center;
      background-color: #e7ebf4;
    }

    tr:nth-child(n+2) td, tr:nth-child(n+2) th {
      border-top: 1px solid rgb(224, 224, 224);
    }
  }
tbody, thead, table{
  border: none !important;
}

#info_list {
  font-size: 1.2rem;
  @include media-breakpoint-down(md) {
    font-size: 1rem;
  }

  .webinar_date {
    @include media-breakpoint-up(md) {
      width: 180px;
    }
  }
}

#description {
  font-size: 1.2rem;

  p {
    margin-bottom: 0
  }
}

#base_info table, #company_info table, #basic-information-wrapper{
  font-size: 1.2rem;
  border-top: 1px solid rgb(224, 224, 224);

  th {
    width: 220px;
    @include media-breakpoint-down(sm) {
      width: 40%;
    }
  }
}

#speaker_area {
  background-image:url("@/assets/section-3.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  img {
    width: 100%;
    height: 250px;
    object-fit: contain;
  }
}
.card {
  background-color: rgba(0, 0, 0, 0.2 ) !important;
}
.card-text{
  p, span{
    color: whitesmoke !important;
  }
}
#company_info {
  table{
    font-size: 0.8rem;
  }
  a {
    color: rgb(33, 37, 41);
  }

  #img_area {
    text-align: center;

    img {
      width: 60%;
      max-height: 300px;
      object-fit: contain;
    }
  }
}


#webinar_list {
  background-image:url("@/assets/section-2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  h3{
    color:var(--primary);
    letter-spacing: 1px;
    font-family: "meiryo" !important;
  }
  #webinar_nav{
    cursor: pointer;
    color:var(--primary);
    letter-spacing: 1px;
    font-family: "meiryo" !important;
  }
  .webinar-card{
    min-height: 225px;
    height: initial !important;
    // container
    border-radius: 1rem;
    margin: 1rem;
    // accesoris
    background-color:white;
    // box-shadow: 0rem 0.25rem 0.5rem rgba(0,0,0,0.1);
    border:solid 0.5px var(--primary-05);
    box-shadow: 0rem 0.25rem 0.5rem var(--primary-03);
    // animation
    cursor: pointer;
    transition:all ease 0.3s;
    .desctiption{
      .webinar{
      // font
      font-weight: bold;
      }
      padding: 0.2rem 1rem 0.2rem 1rem;
    }
  } 
}
</style>